import {KIT_THEME, themes} from './theme/theme';

export const TITLE = {
  [themes.enchant]: 'Enchant',
  [themes.coke]: 'Classic Christmas',
  [themes.lite]: 'Jingle',
}[KIT_THEME];
